<template>
  <collapsible-section class='_pt0 _pb0 _bb1' :collapsed='false'>
    <template #headerText>
      <p class='color-leaf'>{{reportType.name}}</p>
    </template>
    <template #headerActions>
      <router-link tag="a" :to="{path: `/reporting/${reportType.code}`}">
        <span>VIEW ALL</span>
      </router-link>
    </template>
    <template #collapsibleSection>
      <div container>
        <div grid="row wrap">
          <div column="xs-12 s-12 m-12" v-for="(report, i) in reportsToShow" :key="i">
            <label>Posted: {{formatDate(report.requestDate || report.createDate)}}</label>
            <file-download
              @click="handleFileDownload({ reportId: report.reportId, type: reportType.code, fileName: report.fileName })"
              :file-name="report.fileName"
              :file-downloading="reportIsDownloading(report.reportId)"
              :truncate-file-name="false"
            />
          </div>
        </div>
      </div>
    </template>
  </collapsible-section>
</template>

<script>
  import ellipse from '@mixins/ellipse'
  import DateHelper from '@mixins/DateHelper'
  import FileDownload from '@organisms/FileDownload'
  import CollapsibleSection from '@sections/CollapsibleSection'
  import { sortReports } from '@/utils'
  import { useReporting } from '@composables/useReporting'

  export default {
    mixins: [
      ellipse,
      DateHelper
    ],
    components: {
      FileDownload,
      CollapsibleSection
    },
    props: {
      reportType: Object,
      index: Number
    },
    data() {
      return {
        showAll: false
      }
    },
    computed: {
      reportsToShow() {
        if (this.reportType.code === 'EN') {
          if (this.showAll) {
            return sortReports(this.reportType.enrollReports)
          } else {
            return sortReports(this.reportType.enrollReports).slice(0, 6)
          }
        } else {
          if (this.showAll) {
            return sortReports(this.reportType.utilReports)
          } else {
            return sortReports(this.reportType.utilReports).slice(0, 6)
          }
        }
      }
    },
    setup() {
      const { handleFileDownload, reportIsDownloading } = useReporting()
      return {
        handleFileDownload,
        reportIsDownloading
      }
    }
  }
</script>
